<header class="message-view-header">
  <button type="button" class="btn btn-sm btn-icon" aria-label="Back to email list" (click)="backRequested.emit()"><i class="ti ti-arrow-left" aria-hidden="true"></i></button>
  <div class="min-width-0">
    <h3 class="h4 mb-1 text-truncate">{{ message.subject || '(No subject)' }}</h3>
    <div class="small text-secondary text-truncate">From {{ message.from.name || message.from.address }} · {{ message.received_at | localDateTime }}</div>
  </div>
  <button type="button" class="btn btn-primary btn-sm ms-auto" (click)="replyRequested.emit(message)"><i class="ti ti-arrow-back-up me-1" aria-hidden="true"></i>Reply</button>
</header>
<div class="message-addresses small text-secondary">
  <div><strong>To:</strong> {{ message.to[0]?.name || message.to[0]?.address || 'me' }}</div>
  <div *ngIf="message.cc.length"><strong>Cc:</strong> {{ message.cc[0]?.name || message.cc[0]?.address }}<span *ngIf="message.cc.length > 1"> +{{ message.cc.length - 1 }}</span></div>
</div>
<div class="message-body">{{ message.text_body || message.preview }}</div>
<div class="d-flex flex-wrap gap-2 mt-3" *ngIf="message.attachments.length">
  <span class="badge bg-secondary-lt" *ngFor="let attachment of message.attachments"><i class="ti ti-paperclip" aria-hidden="true"></i> {{ attachment.filename }}</span>
</div>
